'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _activityTable = require('./activityTable');

var _activityTable2 = _interopRequireDefault(_activityTable);

var _downloadPayout = require('./downloadPayout');

var _downloadPayout2 = _interopRequireDefault(_downloadPayout);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _kepler = require('kepler');

var _dateRanger = require('./dateRanger');

var _dateRanger2 = _interopRequireDefault(_dateRanger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var notLoading = true;

var Activity = function (_React$Component) {
	_inherits(Activity, _React$Component);

	function Activity(props) {
		_classCallCheck(this, Activity);

		var _this = _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).call(this, props));

		_this.state = {
			loader: false,
			flowType: _this.props.flowType,
			activityMsg: _this.props.activityMsg,
			pageNo: _this.props.activityData.pageNo,
			charityType: _this.props.activityData.charityType,
			transactions: _this.props.activityData.transactions,
			charityName: _this.props.activityData.charityName,
			partnerInfo: _this.props.activityData.partner_info || {},
			donorName: '',
			fromDate: '',
			toDate: '',
			startDate: '',
			endDate: '',
			inputPartnerSelect: '',
			inputProgramSelect: '',
			csrf: (0, _jquery2.default)('body').attr('data-csrf') || '',
			datePattern: _this.props.datepattern ? _this.props.datepattern : 'MM/DD/YY'
		};
		_this.formSubmit = _this.formSubmit.bind(_this);
		_this.updatePartnerSelect = _this.updatePartnerSelect.bind(_this);
		_this.updateProgramSelect = _this.updateProgramSelect.bind(_this);
		_this.clearErrorMsgs = _this.clearErrorMsgs.bind(_this);
		_this.handleDonorName = _this.handleDonorName.bind(_this);
		_this.updateFromDate = _this.updateFromDate.bind(_this);
		_this.updateEndDate = _this.updateEndDate.bind(_this);

		return _this;
	}

	_createClass(Activity, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var oldData = this.state.transactions; // Array of data
			var newData = nextProps.activityData.transactions;
			var pageNo = nextProps.activityData.pageNo;
			(0, _jquery2.default)('#loadmorespinner').hide();
			if (newData.length > 0) {
				notLoading = true;
			} else {
				notLoading = false;
			}
			if (parseInt(pageNo, 10) > 1) {
				var combinedData = oldData.concat(newData);
				this.setState({
					loader: false,
					transactions: combinedData,
					pageNo: nextProps.activityData.pageNo
				});
			} else if (nextProps.activityData.transactions) {
				this.setState({
					loader: false,
					transactions: nextProps.activityData.transactions,
					pageNo: nextProps.activityData.pageNo
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var self = this;

			(0, _jquery2.default)(window).on('scroll', function () {
				if ((0, _jquery2.default)('#activityTable').is(':visible')) {
					var $elem = (0, _jquery2.default)('#activityTable'),
					    $window = (0, _jquery2.default)(window),
					    docViewTop = $window.scrollTop(),
					    docViewBottom = docViewTop + $window.height(),
					    elemTop = $elem.offset().top,
					    elemBottom = elemTop + $elem.height();
					if (elemBottom < docViewBottom && notLoading) {
						(0, _jquery2.default)('#loadmorespinner').show();
						notLoading = false;
						var csrf = self.state.csrf,
						    donorName = (0, _jquery2.default)('.donorName').val();

						var _self$state = self.state,
						    fromDate = _self$state.startDate,
						    toDate = _self$state.endDate;


						if (fromDate.toString().trim().length) {
							fromDate = (0, _moment2.default)(fromDate).format('YYYY/MM/DD').replace(/\//gi, '');
							toDate = (0, _moment2.default)(toDate).format('YYYY/MM/DD').replace(/\//gi, '');
						} else {
							fromDate = '';
							toDate = '';
						}

						var params = {
							_csrf: csrf,
							pageNo: parseInt(self.state.pageNo, 10) + 1,
							donorName: donorName,
							fromDate: fromDate,
							toDate: toDate,
							charityType: self.state.charityType,
							charityName: self.state.charityName,
							partner: self.state.inputPartnerSelect,
							program: self.state.inputProgramSelect
						};
						self.props.gettingNewTransactions(params);
					}
				}
			});

			var PAYPAL = window.PAYPAL || {};

			if (PAYPAL && PAYPAL.analytics) {
				var options = {
					data: {
						page: 'main:cause:ppgf::activity:::',
						pgrp: 'main:cause:ppgf::activity:::'
					}
				};

				PAYPAL.analytics.instance.recordImpression(options);
			}

			(0, _jquery2.default)('#activityTable').on('click', 'tr.campaignAvailable', function () {
				(0, _jquery2.default)(this).toggleClass('selected').next('.transSubDetails').toggle();
				(0, _jquery2.default)('.icon-arrow-down-small', this).toggleClass('icon-arrow-up-small');
				return false;
			});
		}
	}, {
		key: 'handleDonorName',
		value: function handleDonorName() {
			var self = this;
			self.setState({
				donorName: (0, _jquery2.default)('.donorName').val()
			});
		}
	}, {
		key: 'clearErrorMsgs',
		value: function clearErrorMsgs() {
			(0, _jquery2.default)('.fromDateReqErr, .fromDateErr, .toDateErr,.errorMsg1, .errorMsg2, .errorMsg3').addClass('hide');
		}
	}, {
		key: 'formSubmit',
		value: function formSubmit() {
			var self = this;
			var csrf = self.state.csrf,
			    fromDate = self.state.startDate,
			    toDate = self.state.endDate,
			    donorName = (0, _jquery2.default)('.donorName').val();

			(0, _jquery2.default)('.fromDateReqErr, .fromDateErr, .toDateErr,.errorMsg1, .errorMsg2, .errorMsg3').addClass('hide');

			if (donorName && donorName.length < 3) {
				(0, _jquery2.default)('.errorMsg2').removeClass('hide');
				return;
			}

			this.setState({
				loader: true
			});

			if (fromDate.toString().trim().length) {
				fromDate = (0, _moment2.default)(fromDate).format('YYYY/MM/DD').replace(/\//gi, '');
				toDate = (0, _moment2.default)(toDate).format('YYYY/MM/DD').replace(/\//gi, '');
			} else {
				fromDate = '';
				toDate = '';
			}

			var params = {
				_csrf: csrf,
				pageNo: 1,
				donorName: donorName,
				fromDate: fromDate,
				toDate: toDate,
				charityType: self.state.charityType,
				charityName: self.state.charityName,
				partner: self.state.inputPartnerSelect,
				program: self.state.inputProgramSelect
			};
			self.props.gettingNewTransactions(params);
		}
	}, {
		key: 'updatePartnerSelect',
		value: function updatePartnerSelect(option) {
			if (option !== '') {
				this.setState({
					inputPartnerSelect: option
				});
			} else {
				this.setState({
					inputPartnerSelect: '',
					inputProgramSelect: ''
				});
			}
		}
	}, {
		key: 'updateProgramSelect',
		value: function updateProgramSelect(option) {
			if (option !== '') {
				this.setState({
					inputProgramSelect: option
				});
			} else {
				this.setState({
					inputProgramSelect: ''
				});
			}
		}
	}, {
		key: 'updateFromDate',
		value: function updateFromDate(startDate) {
			this.setState({
				startDate: startDate
			});
		}
	}, {
		key: 'updateEndDate',
		value: function updateEndDate(endDate) {
			this.setState({
				endDate: endDate
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var showDropDown = this.state.flowType === 'common';
			var showDownloadCSV = this.state.flowType === 'common';
			var partnerOptions = [];
			var programOptions = [];
			if (showDropDown) {
				var PARTNERINFO = this.state.partnerInfo;
				partnerOptions = PARTNERINFO.map(function (partner_info) {
					return {
						label: partner_info.partner_name,
						value: partner_info.partner_name
					};
				});
				if (this.state.inputPartnerSelect !== '') {
					var i = 0;
					var partner = this.state.inputPartnerSelect;
					var programIndex = PARTNERINFO.find(function (item) {
						return item.partner_name === partner;
					});
					programIndex.program_info.forEach(function (program, programindex) {
						programOptions[i] = {
							label: program.description,
							value: program.gp_program_id
						};
						i++;
					});
				} else {
					var _i = 0;
					PARTNERINFO.forEach(function (item, index) {
						item.program_info.forEach(function (program, programindex) {
							programOptions[_i] = {
								label: program.description,
								value: program.gp_program_id
							};
							_i++;
						});
					});
				}
			}

			return _react2.default.createElement(
				_kepler.Card,
				{ id: 'activityWrapper' },
				_react2.default.createElement(
					'h2',
					{ className: 'activityHeader' },
					this.state.activityMsg.activitytitle
				),
				_react2.default.createElement(_kepler.Loader, {
					show: this.state.loader,
					priority: 10,
					type: 'fixed',
					size: 'lg',
					opacity: 0.5
				}),
				_react2.default.createElement(
					'div',
					{ className: 'alertWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'vx_alert vx_alert-critical fromDateReqErr hide' },
						_react2.default.createElement(
							'p',
							{ className: 'vx_alert-text' },
							this.state.activityMsg.fromdatereq
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'vx_alert vx_alert-critical toDateErr hide' },
						_react2.default.createElement(
							'p',
							{ className: 'vx_alert-text' },
							this.state.activityMsg.entervalidtodate
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'vx_alert vx_alert-critical fromDateErr hide' },
						_react2.default.createElement(
							'p',
							{ className: 'vx_alert-text' },
							this.state.activityMsg.entervalidfromdate
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'vx_alert vx_alert-critical errorMsg1 hide' },
						_react2.default.createElement(
							'p',
							{ className: 'vx_alert-text' },
							this.state.activityMsg.onefieldrequired
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'vx_alert vx_alert-critical errorMsg2 hide' },
						_react2.default.createElement(
							'p',
							{ className: 'vx_alert-text' },
							this.state.activityMsg.donornameshort
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'vx_alert vx_alert-critical errorMsg3 hide' },
						_react2.default.createElement(
							'p',
							{ className: 'vx_alert-text' },
							this.state.activityMsg.daterangeshouldbeless
						)
					)
				),
				_react2.default.createElement(
					_kepler.Form,
					null,
					showDownloadCSV && _react2.default.createElement(
						'div',
						{ className: 'latestPayout' },
						_react2.default.createElement(_downloadPayout2.default, {
							charityType: this.state.charityType,
							charityName: this.state.charityName,
							donorName: this.state.donorName,
							inputPartnerSelect: this.state.inputPartnerSelect,
							inputProgramSelect: this.state.inputProgramSelect,
							csrf: this.state.csrf,
							clearErrorMsgs: this.clearErrorMsgs,
							downloadCSV: this.props.downloadCSV,
							text: this.state.activityMsg.latestPayout,
							type: 'primary',
							btnType: 'latest'
						})
					),
					_react2.default.createElement(
						_kepler.InputGroup,
						null,
						_react2.default.createElement(
							_kepler.InputGroup.Section,
							null,
							showDropDown ? _react2.default.createElement(_kepler.Select, {
								name: 'partneroptions',
								value: this.state.inputPartnerSelect,
								options: partnerOptions,
								onChange: this.updatePartnerSelect,
								size: 'sm',
								placeholder: this.state.activityMsg.allpartners
							}) : '',
							showDropDown ? _react2.default.createElement(_kepler.Select, {
								name: 'programoptions',
								value: this.state.inputProgramSelect,
								options: programOptions,
								onChange: this.updateProgramSelect,
								size: 'sm',
								placeholder: this.state.activityMsg.allprogrammes,
								className: 'selectPrograms'
							}) : '',
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(_kepler.Input, {
									placeholder: this.state.activityMsg.donorname,
									className: 'donorName',
									name: 'donor-name',
									onBlur: this.handleDonorName
								})
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(_dateRanger2.default, {
									texts: this.state.activityMsg,
									updateFromDate: this.updateFromDate,
									updateEndDate: this.updateEndDate,
									datePattern: this.state.datePattern
								})
							)
						)
					),
					_react2.default.createElement(
						_kepler.InputGroup,
						null,
						_react2.default.createElement(
							_kepler.InputGroup.Section,
							null,
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_kepler.Button,
									{
										className: 'filterButton',
										onClick: this.formSubmit
									},
									this.state.activityMsg.filter
								)
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(_downloadPayout2.default, {
									charityType: this.state.charityType,
									charityName: this.state.charityName,
									donorName: this.state.donorName,
									inputPartnerSelect: this.state.inputPartnerSelect,
									inputProgramSelect: this.state.inputProgramSelect,
									csrf: this.state.csrf,
									clearErrorMsgs: this.clearErrorMsgs,
									downloadCSV: this.props.downloadCSV,
									text: this.state.activityMsg.downloadCSV,
									fromDate: this.state.startDate,
									toDate: this.state.endDate,
									type: 'secondary',
									btnType: 'csv'
								})
							)
						)
					)
				),
				_react2.default.createElement(_activityTable2.default, {
					transactions: this.state.transactions,
					activityMsg: this.state.activityMsg,
					gettingNewTransactions: this.props.gettingNewTransactions,
					flowType: this.state.flowType
				}),
				_react2.default.createElement(
					_kepler.Loader,
					{
						show: true,
						priority: 10,
						size: 'md',
						opacity: 0.5,
						id: 'loadmorespinner'
					},
					this.state.activityMsg.loading
				)
			);
		}
	}]);

	return Activity;
}(_react2.default.Component);

Activity.propTypes = {
	activityData: _react.PropTypes.object,
	transactions: _react.PropTypes.object,
	pageNo: _react.PropTypes.number,
	activityMsg: _react.PropTypes.object,
	gettingNewTransactions: _react.PropTypes.func,
	downloadCSV: _react.PropTypes.func,
	flowType: _react.PropTypes.string,
	datepattern: _react.PropTypes.string
};

exports.default = Activity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/ppgf-components/dist/components/Activity.js
// module id = 500
// module chunks = 0